<template lang="html">
  <div class="notfound_wrap">
    <div class="anim_container">
      <div class="anim_bar" id="anim_bar_1"></div>
      <div class="anim_bar" id="anim_bar_2"></div>
      <div class="anim_bar" id="anim_bar_3"></div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="css">
.notfound_wrap{
  width: 100%;
  height: calc(100% - 60px);
  display: flex;
  justify-content: center;
  align-items: center;
}

.anim_container{
  width: 180px;
  height: 100px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
  transform: rotateZ(45deg);
}

.anim_bar{
  position: relative;
  overflow: hidden;
  height: 20px;
  box-shadow: inset 1px -1px 5px rgba(0,0,0,0.2);
  border-radius: 50px;
}

#anim_bar_1{
  width: 100%;
}

#anim_bar_2{
  width: 60%;
}

#anim_bar_3{
  width: 80%;
}

.anim_bar::before{
  position: absolute;
  content: ' ';
  height: 100%;
  background: red;
  border-radius: 50px;
  box-shadow: inset 1px 1px 5px rgba(0,0,0,0.8);
}

#anim_bar_1::before{
  animation: loading 2s ease infinite;
}

#anim_bar_2::before{
  animation: loading 2s ease infinite 0.5s;
}

#anim_bar_3::before{
  animation: loading 2s ease infinite 1s;
}

@keyframes loading{
  0%{
    width: 0%;
  }
  50%{
    width: 100%;
  }
  100%{
    float: right;
    width: 0%;
  }
}
</style>
